export default __webpack_public_path__ + "static/media/GothaBol.90d58492.otf";